/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2025. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2025. Todos los derechos reservados.
 */

/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez Cumbe
 * Date:         06/07/25 - 8:35
 * Module name:  valid-home-safe
 * File name:    valid-home-safe.guard.ts
 * IDE:          WebStorm
 */

import {CanActivateFn, UrlTree} from '@angular/router';
import {inject} from '@angular/core';
import {MkadUserCustomersService} from '@shared/services';
import {ManageSessionStore, ManageSessionStoreType} from '@auth/sotre/management-session.store';
import {UserProfileInterface} from '@shared/interface';
import {catchError, Observable, of, switchMap, zip} from 'rxjs';
import {map} from 'rxjs/operators';

export const ValidHomeSafeGuard: CanActivateFn = (_route): Observable<boolean | UrlTree> => {
  const userCustomer: MkadUserCustomersService = inject(MkadUserCustomersService);
  const management: ManageSessionStoreType = inject(ManageSessionStore);

  const userResponse = (userData: UserProfileInterface) => {
    const {email, first_name, last_name, profile} = userData;
    management.preferencesRef().userSettings = {
      ...profile,
      email,
      first_name,
      last_name,
    };
  };

  const zipGetUserAndCustomerData = () => zip(
    management.preferencesRef().getProfileData(),
    userCustomer.getCustomer()
  );

  return management.authServiceRef().isAuthenticated()
    .pipe(
      switchMap((authenticated: boolean) => {
        console.log('valid-home-safe');
        console.log({authenticated});
        console.log({customer: management.preferencesRef().userCustomer()});
        if (!authenticated) {
          return of(true);
        }

        return zipGetUserAndCustomerData().pipe(
          map(([profile, customer]) => {
            if (profile) userResponse(profile);

            management.preferencesRef().userCustomer.set(customer);

            return true;
          }),
          catchError(() => {
            return of(false);
          }),
        );

      })
    );
};

